var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch-container pl-1 d-flex",class:_vm.start ? 'justify-start' : 'justify-center ml-2 '},[_c('v-switch',{staticClass:"mt-0 pt-0",attrs:{"id":_vm.attachId,"input-value":_vm.value,"hide-details":"","flat":"","disabled":_vm.disabled,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }